export const selectCart = state => state.cart.items;
export const selectIsLoading = state => state.cart.loading;
export const selectError = state => state.cart.error;
